import { useScript } from '#imports'

import { noop } from '@backmarket/utils/function/noop'

import { SIGNIFYD_LIBRARY_URL } from '../config/signifyd/constants'
import {
  getOrSetSignifydSessionId,
  resetSignifydSessionId,
} from '../utils/signifydSessionId'

/**
 * Returns a unique session ID for Signifyd. Loads the library if needed.
 */
export const useSignifyd = () => {
  if (import.meta.server) {
    // We need cookies to store the session id
    // to simplify we don't load the library on the server
    return { load: noop, reset: noop }
  }

  const sessionId = getOrSetSignifydSessionId()
  const { load, status } = useScript(
    {
      'data-order-session-id': sessionId,
      id: 'sig-api',
      src: SIGNIFYD_LIBRARY_URL,
    },
    {
      trigger: 'manual',
    },
  )

  return {
    /** Load the signifyd library if needed and return the session id */
    load: async () => {
      if (status.value === 'loaded') {
        return sessionId
      }

      try {
        await load()

        return sessionId
      } catch (error) {
        // This script can be blocked by extensions like Ghostery.
        // To avoid blocking the payment it will make a silent catch
        // Also, useScriptTag should already have logged the error
      }

      return null
    },
    /** Reset the signifyd session id */
    reset: async () => {
      resetSignifydSessionId()
    },
  }
}
